import React from "react";
import { Typography, Card } from 'antd';

const { Title } = Typography;
const MapLocation = () => {
  return (
    <Card style={{ margin: '24px' }}>

        <Title level={2} style={{ textAlign: "center", marginBottom: "48px" }}>
          Location
        </Title>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2760.809058392106!2d10.174443277391191!3d46.21425328308121!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4783bd9fe41beff5%3A0xf786744536503eb6!2sCa&#39;%20De%20Campo!5e0!3m2!1sen!2sit!4v1744214156861!5m2!1sen!2sit"
          width="100%"
          height="600px"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ca' De Campo Location"
        />

    </Card>
  );
};

export default MapLocation;
